import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { BadgeDollarSign, Copy, Save } from "lucide-react";

import { ComprasModalNuevoGasto } from "../../compras/form/ComprasModalNuevoGasto";
import { DialogFormBuy } from "../../compras/miniForm/DialogFormBuy";
import { Buttons } from "../../reusableUI/v2UI/Buttons";

/* import { useBuy } from "../../../hooks/useBuy"; */

import {
  iniSaveBudget,
  iniUpdateBudget,
  iniCreateBudgetDuplicate,
} from "../../../redux/actions/pptosGastos";
import { ButtonsCreate } from "../../reusableUI/v2UI/ButtonsCreate";

export const FormActions = ({
  loadIniBudget,
  setOpenNewBuy,
  openNewBuy,
  initCreateBuy,
  detailBuy,
  getItemsSelected,
  handleAddBuy,
}) => {
  /* const { detailBuy, initCreateBuy } = useBuy(); */
  /* const [openNewBuy, setOpenNewBuy] = useState(false); */

  const [openExtendedMode, setOpenExtendedMode] = useState(false);
  const [dataFormBuy, setDataFormBuy] = useState({});

  const urlParams = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* const generalParams = useSelector((state) => state.general); */
  const detailBudget = useSelector((state) => state.pptoGasto.detail);
  const { id } = detailBudget;

  const handleSave = () => {
    if (id > 0) {
      dispatch(iniUpdateBudget(detailBudget, urlParams.budgetId));
    } else {
      dispatch(iniSaveBudget(detailBudget, navigate));
    }
  };

  /* const handleAddBuy = async () => {
    const itemsSelected = await getItemsSelected(detailBudget.items);

    if (itemsSelected.length === 0) {
      toast.warning("Falta seleccionar ítem para comprar");
      return false;
    }

    await initCreateBuy({
      origen: "gastos_internos",
      itemsSelected,
      detailBudget,
      generalParams,
    });

    setOpenNewBuy(true);
  }; */

  /* const getItemsSelected = async (titles) => {
    let itemsSelected = [];

    for (let i = 0; i < titles.length; i++) {
      const currentTitle = titles[i];
      const filtered = currentTitle.items.filter((it) => it.selected === true);

      for (let x = 0; x < filtered.length; x++) {
        itemsSelected = [...itemsSelected, filtered[x]];
      }
    }

    return itemsSelected;
  }; */

  const handleOpenExtendedMode = (dataForm) => {
    setDataFormBuy(dataForm);
    setOpenExtendedMode(true);
    setOpenNewBuy(false);
  };

  const handleDuplicate = () => {
    dispatch(iniCreateBudgetDuplicate(detailBudget));
    navigate(`/gastos/pptos/0`);
  };

  return (
    <>
      {openNewBuy && (
        <DialogFormBuy
          title="Nuevo gasto"
          open={openNewBuy}
          setOpen={setOpenNewBuy}
          initialState={detailBuy}
          handleOpenExtendedMode={handleOpenExtendedMode}
          loadIniBudget={loadIniBudget}
        />
      )}

      {openExtendedMode && (
        <ComprasModalNuevoGasto
          title="Nuevo gasto"
          open={openExtendedMode}
          setOpenExtendedMode={setOpenExtendedMode}
          initialState={dataFormBuy}
          loadIniBudget={loadIniBudget}
        />
      )}

      <div>
        <Buttons
          title="Guardar cambios"
          name="Guardar"
          icon={<Save size={20} />}
          handleClick={handleSave}
        />
      </div>

      <div>
        <Buttons
          title="Duplicar y crear nuevo"
          name="Duplicar"
          icon={<Copy size={20} />}
          handleClick={handleDuplicate}
        />
      </div>

      {id > 0 && id !== null && (
        <ButtonsCreate
          name="Ejecutar gasto"
          icon={<BadgeDollarSign size={20} />}
          handleClick={handleAddBuy}
        />
      )}
    </>
  );
};
